import * as React from "react";

const SvgIcon: React.FC<React.SVGProps<SVGElement>> = ({ width = 11, height = 9 }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 17 15"
    >
        <path fill="#1C6BFF" d="M8.5 15 .273.75h16.454z"></path>
    </svg>
);

export default React.memo(SvgIcon);
